import { FormEvent, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import logo from '../../assets/logo-badge.webp';

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setError('');
    setBusy(true);
    try {
      await login(username.trim(), password);
      navigate('/', { replace: true });
    } catch (err: any) {
      setError(err?.status === 401 ? 'Usuario o contraseña incorrectos.' : (err?.message || 'Error al iniciar sesión.'));
    } finally {
      setBusy(false);
    }
  }

  return (
    // force-light: el login siempre se ve claro y limpio, sin importar el tema activo.
    <div className="force-light relative flex min-h-full items-center justify-center overflow-hidden bg-canvas p-4 text-content">
      {/* Resplandor de marca de fondo */}
      <div className="pointer-events-none absolute -top-24 left-1/2 h-72 w-72 -translate-x-1/2 rounded-full bg-accent/30 blur-3xl" />
      <form
        onSubmit={onSubmit}
        className="relative w-full max-w-sm rounded-2xl border border-line bg-surface p-8 shadow-xl"
      >
        <div className="mb-6 flex flex-col items-center gap-3">
          <div className="relative">
            <div className="absolute inset-0 -m-1 rounded-full bg-accent/40 blur-md" />
            <img src={logo} alt="Let's Move Dance & Fitness" className="relative h-28 w-28 rounded-full bg-white object-contain shadow-md ring-4 ring-accent/60" />
          </div>
          <div className="text-center">
            <h1 className="font-display text-2xl font-extrabold tracking-wide text-content">LET'S MOVE</h1>
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-content-3">Dance &amp; Fitness</p>
          </div>
        </div>

        {error && (
          <div className="mb-4 rounded-lg border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700">
            {error}
          </div>
        )}

        <label className="mb-1 block text-sm font-medium text-content-2">Usuario / Correo</label>
        <input
          type="text"
          autoFocus
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          className="mb-4 w-full rounded-lg border border-line bg-surface px-3 py-2 text-sm outline-none focus:border-brand-blue focus:ring-2 focus:ring-brand-blue/30"
          placeholder="tucorreo@ejemplo.com"
        />

        <label className="mb-1 block text-sm font-medium text-content-2">Contraseña</label>
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="mb-6 w-full rounded-lg border border-line bg-surface px-3 py-2 text-sm outline-none focus:border-brand-blue focus:ring-2 focus:ring-brand-blue/30"
          placeholder="••••••••"
        />

        <button
          type="submit"
          disabled={busy || !username || !password}
          className="w-full rounded-lg bg-accent-solid py-2.5 text-sm font-semibold text-on-accent transition hover:bg-accent-solid/90 disabled:cursor-not-allowed disabled:bg-line disabled:text-content-3"
        >
          {busy ? 'Entrando…' : 'Iniciar sesión'}
        </button>

        <div className="mt-4 text-center">
          <a href="/recuperar" className="text-sm text-content-3 underline transition hover:text-content-2">¿Olvidaste tu contraseña?</a>
        </div>
      </form>
    </div>
  );
}
